<template>
    <div class="cont">
         <div class="title04">{{helpDetail.title}}</div>
         <div class="counttext" v-html="helpDetail.content"></div>
    </div>
</template>
<script>
  export default {
    data(){
      return {
        helpDetail:{}
      }
    },
    methods:{
      init(item){
        this.helpDetail = item
      }
    }
  }
</script>
<style scoped>
.cont{
    padding: 40px;
    display: flex;
    flex-direction: column;
}
.title04{
    height: 26px;
font-size: 20px;
font-family: Microsoft YaHei;
font-weight: 400;
line-height: 48px;
color: #333333;
text-align: center;
}
.time{
    font-size: 12px;
font-family: Microsoft YaHei;
font-weight: 400;
line-height: 48px;
color: #888888;
text-align: center;
margin-top: 10px;
margin-bottom: 10px;
}
.time span{
    margin-left: 20px;
}
.counttext{
    text-indent: 20px;
    line-height: 24px;
    font-size: 14px;
    margin-top: 40px;
}
.counttext img{

}
</style>



// WEBPACK FOOTER //
// src/views/components/view.vue